import { DialogTitle, Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Dialog, DialogActions, DialogContent, DialogContentText } from "@mui/material";
import axios from "axios";
import { use, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack, } from "react-icons/md";
import { Commet } from "react-loading-indicators";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { Button } from "rsuite";
import { web_url } from "../../constant";
import i18n from "../../i18n";


function ClassDetailsPage({ t }) {
    const isXlOrLarger = useMediaQuery({ minWidth: 1270 });
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    const [studentArray, setStudentArray] = useState([
        { userFullName: "Abinaya ratnasingam", activity: "None", accountStatus: "ACTIVE" }
    ])

    const [isLoading, setIsLoading] = useState(false);

    const [searchInput, setSearchInput] = useState("");

    const [filteredStudents, setFilteredStudents] = useState(() => studentArray.filter((student) =>
        student.userFullName.toLowerCase().includes(searchInput.toLowerCase())
    ))

    const [filteredStudentsForFilters, setFilteredStudentsForFilters] = useState(() => studentArray.filter((student) =>
        student.userFullName.toLowerCase().includes(searchInput.toLowerCase())
    ))

    const [folderSelected, setFolderSelected] = useState({
        all: true,
        inactive: false,
        active: false
    })

    useEffect(() => {
        let tempFilteredStudents = studentArray;

        // Apply folder filter
        if (folderSelected.inactive) {
            tempFilteredStudents = tempFilteredStudents.filter((student) =>
                student.accountStatus.toLowerCase().includes('inactive')
            );
        } else if (folderSelected.active) {
            tempFilteredStudents = tempFilteredStudents.filter((student) =>
                !student.accountStatus.toLowerCase().includes('inactive')
            );
        }

        // Apply search filter
        if (searchInput.trim() !== '') {
            tempFilteredStudents = tempFilteredStudents.filter((student) =>
                student.userFullName.toLowerCase().includes(searchInput.toLowerCase())
            );
        }

        setFilteredStudents(tempFilteredStudents);
    }, [folderSelected, searchInput, studentArray]);

    useEffect(() => {
        localStorage.removeItem('studentselectedbyteacher')
    }, [])

    const downloadCSV = () => {
        setIsLoading(true);
        if (studentArray.length === 0) {
            handleClickOpenError("no data found to download");
            return;
        }

        const selectedFields = ['userFullName', 'accountStatus', 'activity', 'userEmail'];

        const headers = selectedFields.join(',');

        const rows = studentArray.map(student =>
            selectedFields.map(field => `"${student[field] || ''}"`).join(',') // Ensure empty values are handled
        );

        const csvContent = [headers, ...rows].join('\n');

        const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'students.csv'); // Set the filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setIsLoading(false);
    };


    const [openError, setOpenError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setErrorMsg(t('t93'));
        } else if ('no data found to download') {
            setErrorMsg(t('t134'));
        } else {
            setErrorMsg(t('t94'));
        }
        setIsLoading(false);
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        if (isXlOrLarger) {
            navigate('/desktop/teacher/dashboard')
        } else {
            navigate('/mobile/teacher/dashboard')
        }

    };


    useEffect(() => {

        if (localStorage.getItem("name")) {
            const teacher = {
                assignedClass: localStorage.getItem("assignedClass"),
                district: localStorage.getItem('district'),
                school: localStorage.getItem('school')
            };
            setIsLoading(true);

            const getLogDetails2 = () => {
                return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
            };
            const logDetails2 = getLogDetails2();

            const config = {
                headers: {
                    "Content-Type": "application/json",
                    'Authorization': `Bearer ${logDetails2.token}`,
                },
            };

            axios.post(`${web_url}/api/auth/students/filter`, teacher, config)
                .then((response) => {
                    // console.log("API Response from Students Filter:", response.data);
                    const studentData = response.data; // Student array from API 1
                    setStudentArray(studentData);

                    const getLogDetails2 = () => {
                        return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
                    };
                    const logDetails2 = getLogDetails2();

                    const configToken = {
                        headers: {
                            'Authorization': `Bearer ${logDetails2.token}`,
                        },
                    };

                    axios.get(`${web_url}/api/email-threads/student-activity`, configToken)
                        .then((activityResponse) => {
                            // console.log("API Response from Student Activity:", activityResponse.data);
                            const activityData = activityResponse.data;

                            // Map through the student array and add the activity field
                            const updatedStudentArray = studentData.map((student) => {
                                // Find matching activity for the student
                                const matchingActivity = activityData.find((activity) =>
                                    activity.studentName === student.userFullName &&
                                    activity.school === student.school &&
                                    activity.grade === student.grade
                                );

                                // Add the activity field to the student
                                return {
                                    ...student,
                                    activity: matchingActivity ? matchingActivity.activity : "Unknown", // Default to "Unknown" if no match
                                };
                            });

                            setStudentArray(updatedStudentArray); // Update state with enriched data
                            setIsLoading(false);
                        })
                        .catch((err) => {
                            setIsLoading(false);
                            if (err.response) {
                                // console.error(err.response);
                                if (err.response.data.error) {
                                    handleClickOpenError(err.response.data.error);
                                } else if (err.response.data.message) {
                                    handleClickOpenError(err.response.data.message);
                                } else if (err.response.data.token) {
                                    handleClickOpenError(err.response.data.token);
                                } else {
                                    handleClickOpenError("An unknown error occurred");
                                }
                            }
                        });

                })
                .catch((err) => {
                    if (err.response) {
                        // console.error(err.response);
                        if (err.response.data.error) {
                            handleClickOpenError(err.response.data.error);
                        } else if (err.response.data.message) {
                            handleClickOpenError(err.response.data.message);
                        } else if (err.response.data.token) {
                            handleClickOpenError(err.response.data.token);
                        } else {
                            handleClickOpenError("An unknown error occurred");
                        }
                    }
                    setIsLoading(false);
                });
        }
    }, []);

    const [tooltipPosition, setTooltipPosition] = useState({ x: 0, y: 0 });
    const [showTooltip, setShowTooltip] = useState(false);

    const handleMouseMove = (e) => {
        setTooltipPosition({ x: e.clientX, y: e.clientY });
    };

    return (
        <>
            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} overflow-x-hidden w-screen xl:pt-[20px] pb-[120px]`}>
                <div className="pt-[100px] md:pt-[130px] lg:pt-[150px] xl:pt-[0px] w-full flex justify-between items-center">
                    <div className="ml-[30px] md:ml-[60px] lg:ml-[80px] xl:ml-[80px] w-full flex justify-start flex items-center">
                        <MdArrowBack size={25} className="md:hidden" onClick={() => {
                            navigate('/mobile/teacher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                            navigate('/mobile/teacher/dashboard')
                        }} />
                        <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                            navigate('/desktop/teacher/dashboard')
                        }} />
                        <p className="text-[20px] md:text-[23px] lg:text-[25px] xl:text-[20px] 2xl:text-[22px] font-bold px-[10px] py-[5px] md:px-[13px] md:py-[8px]">{t('t108')}</p>
                    </div>
                    <div className="mr-[20px] md:mr-[100px] lg:mr-[130px] xl:mr-[80px]">
                        <button disabled={isLoading} className="bg-[#FDC50C] text-black rounded-md text-[15px] md:text-[17px] lg:text-[19px] 2xl:text-[21px] py-[5px] px-[10px] hover:bg-opacity-20" onClick={downloadCSV}>{t('t133')}</button>
                    </div>
                </div>
                <div className="mx-[20px] md:mx-[100px] lg:mx-[130px] xl:mx-[250px] mb-[5px]">
                    <input
                        type="search"
                        placeholder="Search"
                        onChange={(e) => setSearchInput(e.target.value)}
                        value={searchInput}
                        className="mt-4 p-2 md:p-3 lg:p-4 xl:p-1 2xl:p-2 border border-gray-300 rounded-md w-full text-black text-[15px] md:text-[18px]"
                    />
                </div>

                {
                    isLoading ? <div className="items-center justify-center flex pt-[30px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div> : <>
                        <div className="hidden md:flex mb-[20px] justify-center xl:justify-start items-center gap-[10px] xl:mx-[250px]">
                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.all ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => setFolderSelected({ inactive: false, all: true, active: false })} >{t('t130')}</button>
                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.active ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => setFolderSelected({ active: true, all: false, inactive: false })}>{t('t131')}</button>
                            <button className={`text-[15px] md:text-[20px] xl:text-[16px] rounded-md px-[15px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.inactive ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => setFolderSelected({ active: false, all: false, inactive: true })}>{t('t132')}</button>
                        </div>

                        <div className="md:hidden mb-[20px] grid grid-cols-3 justify-center xl:justify-start gap-[10px] xl:mx-[250px] px-[20px]">
                            <button className={`w-[100px] h-auto text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[5px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.all ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => setFolderSelected({ inactive: false, all: true, active: false })}>{t('t130')}</button>
                            <button className={`w-[100px] h-auto text-[15px] md:text-[20px] xl:text-[16px] md:mr-[10px] rounded-md px-[5px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.active ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => setFolderSelected({ active: true, all: false, inactive: false })}>{t('t131')}</button>
                            <button className={`w-[100px] h-auto text-[15px] md:text-[20px] xl:text-[16px] rounded-md px-[5px] py-[5px] md:py-[10px] md:px-[20px] xl:py-[1px] xl:px-[10px] border border-1 mt-[10px] border-gray-400 text-gray-700 ${folderSelected.inactive ? 'bg-[#FFEBA9] text-[#816D2B]' : 'bg-[#F1F6FB] text-[#8189B0]'}`} onClick={() => setFolderSelected({ active: false, all: false, inactive: true })}>{t('t132')}</button>
                        </div>

                        {/* <div className="hidden md:block xl:hidden flex w-full justify-center items-center">
                            <p className="text-[13px] md:text-[17px] text-black px-[30px]">{t('t413')}</p>
                        </div> */}

                        <div className="hidden md:grid md:grid-cols-7 mt-[5px] bg-[#FDC50C] py-[10px] mx-[20px] md:mx-[100px] lg:mx-[130px] xl:mx-[250px] rounded-t-xl items-center justify-center">
                            <div className="md:col-span-3 text-black text-[12px] md:text-[14px] lg:text-[16px] flex justify-center md:justify-start font-bold md:pl-[40px]">
                                <p>{t('t136')}</p>
                            </div>
                            <div className="md:col-span-2 xl:col-span-3 text-black text-[12px] md:text-[14px] lg:text-[16px] flex justify-center font-bold break-words text-center w-full">
                                <p>{t('t137')}</p>
                            </div>
                            <div className="text-black text-[12px] md:text-[14px] lg:text-[16px] flex justify-center font-bold">
                                <p>{t('t138')}</p>
                            </div>
                        </div>

                        <div className="md:hidden px-[25px]">
                            {filteredStudents.length > 0 ?
                                filteredStudents.map((student, index) => (
                                    <div key={index} >
                                        <div className="flex justify-between items-center bg-[#FFF4CE] bg-opacity-70 border border-[1px] border-[#FDC50C] rounded-lg mb-[10px] pl-[20px] pr-[10px] py-[10px]">
                                            <div className="flex flex-col items-start">
                                                <div className="text-black text-[12px] flex justify-center ">
                                                    <p>{student.userFullName.length > 30
                                                        ? `${student.userFullName.slice(0, 30)}...`
                                                        : student.userFullName}</p>
                                                </div>
                                                <div className="text-black  flex justify-center ">
                                                    <p className={`text-black text-[12px] font-bold`}>{t('t137')} - {student.activity !== "None" ? (student.activity === "1" ? `${student.activity} mail` : `${student.activity} mails`) : `${t('t417')}`}</p>
                                                </div>
                                            </div>
                                            <div className="text-black  flex justify-center font-bold flex-col">
                                                <button className={`text-[12px] ${student.accountStatus == "ACTIVE" ? 'bg-[#BBFFA3]' : 'bg-[#FFBEA3]'}  text-black rounded-lg py-[3px] w-[100px] mb-[5px]`}>{student.accountStatus === "ACTIVE" ? t("t131_1") : t("t132_1")}</button>
                                                <button
                                                    onClick={() => {
                                                        localStorage.setItem('studentselectedbyteacher', JSON.stringify(student));
                                                        navigate('/teacher/student/viewprofle');
                                                    }}
                                                    className={`bg-[#FDC50C]  text-black text-[12px] rounded-lg py-[3px] w-[100px]`}>{t('t207')}</button>
                                            </div>
                                        </div>
                                    </div>
                                ))
                                :
                                <div className="flex justify-center py-[10px] xl:py-[20px] text-[15px] xl:text-[17px]">
                                    <p>{t('t135')}</p>
                                </div>

                            }

                        </div>

                        <div className="hidden md:block bg-[#FFF4CE] rounded-b-xl mx-[20px] md:mx-[100px] lg:mx-[130px] xl:mx-[250px]">
                            {filteredStudents.length > 0 ?
                                filteredStudents.map((student, index) => (
                                    <div key={index}>

                                        <div className={`hidden md:grid lg:hidden grid-cols-7 py-[6px] items-center ${index === filteredStudents.length - 1 ? "" : "border-b border-[#FDC50C]"}`}>
                                            <div className="col-span-3 text-black text-[15px] flex justify-start ml-[40px] ">
                                                <p>{student.userFullName.length > 23
                                                    ? `${student.userFullName.slice(0, 23)}...`
                                                    : student.userFullName}</p>
                                            </div>
                                            <div className="col-span-2 text-black  flex justify-center ">
                                                <p className={`text-black text-[14px] font-bold`}>{student.activity !== "None" ? (student.activity === "1" ? `${student.activity} ${t('t14')}` : `${student.activity} ${t('t14_1')}`) : `${t('t417')}`}</p>
                                            </div>
                                            <div className="text-black text-[14px] flex justify-center font-bold">
                                                <button className={`text-[12px] ${student.accountStatus == "ACTIVE" ? 'bg-[#BBFFA3]' : 'bg-[#FFBEA3]'}  text-black rounded-lg py-[3px] w-[120px]`}>{student.accountStatus === "ACTIVE" ? t("t131_1") : t("t132_1")}</button>
                                            </div>
                                            <div className="text-black text-[16px] flex justify-center font-bold">
                                                <button
                                                    onClick={() => {
                                                        localStorage.setItem('studentselectedbyteacher', JSON.stringify(student));
                                                        navigate('/teacher/student/viewprofle');
                                                    }}
                                                    className={`w-[70px] bg-[#FDC50C] text-black text-[11px] rounded-lg py-[3px] `}>{t('t207')}</button>
                                            </div>
                                        </div>

                                        <div className={`hidden lg:grid xl:hidden grid-cols-7 py-[6px] items-center ${index === filteredStudents.length - 1 ? "" : "border-b border-[#FDC50C]"}`}>
                                            <div className="col-span-3 text-black text-[16px] flex justify-start ml-[40px] ">
                                                <p>{student.userFullName.length > 28
                                                    ? `${student.userFullName.slice(0, 28)}...`
                                                    : student.userFullName}</p>
                                            </div>
                                            <div className="col-span-2 text-black  flex justify-center ">
                                                <p className={`text-black text-[16px] font-bold`}>{student.activity !== "None" ? (student.activity === "1" ? `${student.activity} ${t('t14')}` : `${student.activity} ${t('t14_1')}`) : `${t('t417')}`}</p>
                                            </div>
                                            <div className="text-black text-[14px] flex justify-center font-bold">
                                                <button className={`${student.accountStatus == "ACTIVE" ? 'bg-[#BBFFA3]' : 'bg-[#FFBEA3]'}  text-black text-[13px] rounded-lg py-[3px] w-[120px]`}>{student.accountStatus === "ACTIVE" ? t("t131_1") : t("t132_1")}</button>
                                            </div>
                                            <div className="text-black text-[16px] flex justify-center font-bold">
                                                <button
                                                    onClick={() => {
                                                        localStorage.setItem('studentselectedbyteacher', JSON.stringify(student));
                                                        navigate('/teacher/student/viewprofle');
                                                    }}
                                                    className={`bg-[#FDC50C] text-black text-[13px] rounded-lg py-[3px] w-[100px]`}>{t('t207')}</button>
                                            </div>
                                        </div>

                                        <div className="cursor-pointer hidden xl:grid 2xl:hidden grid-cols-7 py-[6px] items-center hover:bg-opacity-10 hover:bg-black hover:rounded-b-lg relative group "
                                            onMouseMove={handleMouseMove}
                                            onMouseEnter={() => setShowTooltip(true)}
                                            onMouseLeave={() => setShowTooltip(false)}
                                            onClick={() => {
                                                localStorage.setItem('studentselectedbyteacher', JSON.stringify(student));
                                                navigate('/teacher/student/viewprofle');
                                            }}
                                        >
                                            <div className="col-span-3 text-black text-[16px] flex justify-start pl-[40px]">
                                                <p>{student.userFullName.length > 35
                                                    ? `${student.userFullName.slice(0, 35)}...`
                                                    : student.userFullName}</p>
                                            </div>
                                            <div className="col-span-3 text-black  flex justify-center ">
                                                <p className={`text-black text-[16px] font-bold`}>{student.activity !== "None" ? (student.activity === "1" ? `${student.activity} ${t('t14')}` : `${student.activity} ${t('t14_1')}`) : `${t('t417')}`}</p>
                                            </div>
                                            <div className=" text-black text-[16px] flex justify-center font-bold pr-[5px]">
                                                <button className={`${student.accountStatus == "ACTIVE" ? 'bg-[#BBFFA3]' : 'bg-[#FFBEA3]'}  text-black text-[15px] rounded-lg py-[3px] w-[130px]`}>{student.accountStatus === "ACTIVE" ? t("t131_1") : t("t132_1")}</button>
                                            </div>
                                            {showTooltip && (
                                                <div
                                                    className="absolute px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-100 transition-opacity whitespace-nowrap pointer-events-none"
                                                    style={{
                                                        top: tooltipPosition.y + 10, // Adjust distance below cursor
                                                        left: tooltipPosition.x + 10, // Adjust distance from cursor
                                                        position: "fixed", // Ensures it follows the cursor
                                                    }}
                                                >
                                                    {t("t412")}
                                                </div>
                                            )}
                                        </div>

                                        <div className="cursor-pointer hidden 2xl:grid 2xl:grid-cols-7 py-[6px] items-center hover:bg-opacity-10 hover:bg-black hover:rounded-b-lg relative group"
                                            onMouseMove={handleMouseMove}
                                            onMouseEnter={() => setShowTooltip(true)}
                                            onMouseLeave={() => setShowTooltip(false)}
                                            onClick={() => {
                                                localStorage.setItem('studentselectedbyteacher', JSON.stringify(student));
                                                navigate('/teacher/student/viewprofle');
                                            }}
                                        >
                                            <div className="col-span-3 text-black text-[17px] flex justify-start xl:pl-[40px] ">
                                                <p>{student.userFullName.length > 45
                                                    ? `${student.userFullName.slice(0, 45)}...`
                                                    : student.userFullName}</p>
                                            </div>
                                            <div className="col-span-3 text-black  flex justify-center ">
                                                <p className={`text-black text-[17px] font-bold`}>{student.activity !== "None" ? (student.activity === "1" ? `${student.activity} ${t('t14')}` : `${student.activity} ${t('t14_1')}`) : `${t('t417')}`}</p>
                                            </div>
                                            <div className="text-black text-[16px] flex justify-center font-bold pr-[10px]">
                                                <button className={`${student.accountStatus == "ACTIVE" ? 'bg-[#BBFFA3]' : 'bg-[#FFBEA3]'}  text-black text-[17px] rounded-lg py-[3px] w-[180px]`}>{student.accountStatus === "ACTIVE" ? t("t131_1") : t("t132_1")}</button>
                                            </div>
                                            {showTooltip && (
                                                <div
                                                    className="absolute px-2 py-1 text-white text-sm bg-gray-800 rounded opacity-100 transition-opacity whitespace-nowrap pointer-events-none"
                                                    style={{
                                                        top: tooltipPosition.y + 10, // Adjust distance below cursor
                                                        left: tooltipPosition.x + 10, // Adjust distance from cursor
                                                        position: "fixed", // Ensures it follows the cursor
                                                    }}
                                                >
                                                    {t("t412")}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )) :
                                <div className="flex justify-center py-[10px] xl:py-[20px] text-[15px] xl:text-[17px]">
                                    <p>{t('t135')}</p>
                                </div>
                            }
                        </div>
                    </>
                }

            </div>
            <Dialog
                open={open}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleClose(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm mr-[30px] md:mr-[0px]"
            >
                <DialogContent className="bg-[#FFF6DA]">
                    {!isLoading &&
                        <DialogContent
                            id="custom-dialog-description"
                            className="text-gray-600 text-md mt-2"
                        >
                            <div className='flex flex-col justify-center items-center text-center'>
                                <img src='/images/success.svg' alt='success' />
                                <div className='mt-[30px]'>{t('t129')}</div>
                                <Button
                                    onClick={handleClose}
                                    className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md mt-[10px]"
                                    style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                                >
                                    {t('t13')}
                                </Button>
                            </div>
                        </DialogContent>
                    }

                </DialogContent>
            </Dialog>

            <Dialog
                open={openError}
                onClose={(event, reason) => {
                    if (reason !== "backdropClick") {
                        handleCloseError(); // Allow closing only for other reasons
                    }
                }}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {errorMsg}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ClassDetailsPage;
